import type { HmiElement } from "../schema/hmi-canvas.schema";

export type HmiElementRegistryEntry = {
  type: HmiElement["type"];
  title: string;
  category: "primitive" | "telemetry" | "command";
  bindable: boolean;
};

export const hmiElementRegistry: HmiElementRegistryEntry[] = [
  { type: "text", title: "Text", category: "primitive", bindable: false },
  { type: "value", title: "Value", category: "telemetry", bindable: true },
  { type: "stat_card", title: "Stat Card", category: "telemetry", bindable: true },
  { type: "data_table", title: "Data Table", category: "telemetry", bindable: true },
  { type: "rectangle", title: "Rectangle", category: "primitive", bindable: false },
  { type: "circle", title: "Circle", category: "primitive", bindable: false },
  { type: "line", title: "Line", category: "primitive", bindable: false },
  { type: "arrow", title: "Arrow", category: "primitive", bindable: false },
  { type: "flow_line", title: "Flow Line", category: "primitive", bindable: false },
  { type: "trend_chart", title: "Trend Chart", category: "telemetry", bindable: true },
  { type: "gauge", title: "Gauge", category: "telemetry", bindable: true },
  { type: "symbol_instance", title: "Symbol Instance", category: "primitive", bindable: false },
  { type: "svg_asset", title: "SVG Asset", category: "primitive", bindable: false },
  { type: "image_asset", title: "Image Asset", category: "primitive", bindable: false },
  { type: "command_button", title: "Command Button", category: "command", bindable: false },
  { type: "command_toggle", title: "Command Toggle", category: "command", bindable: true },
  { type: "setpoint", title: "Setpoint", category: "command", bindable: true },
];

export function getRegistryEntry(type: HmiElement["type"]): HmiElementRegistryEntry | undefined {
  return hmiElementRegistry.find((entry) => entry.type === type);
}
